import React from "react";

function Duplicate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 32 32"
    >
      <g fill="#c34343">
        <path
          d="M11.429 16a5.715 5.715 0 10-5.715-5.714A5.72 5.72 0 0011.429 16zm7.476 4.721A10.434 10.434 0 001 28a1 1 0 001 1h18.86a1 1 0 001-1 10.067 10.067 0 00-.485-3.124 10.36 10.36 0 00-2.47-4.155z"
          data-original="#000000"
        ></path>
        <circle cx="23.5" cy="12.25" r="4.25" data-original="#000000"></circle>
        <path
          d="M23.5 17.67a7.482 7.482 0 00-3.806 1.057c.217.194.436.385.641.595a12.388 12.388 0 012.952 4.966 11.488 11.488 0 01.437 1.882H30a1 1 0 001-1 7.508 7.508 0 00-7.5-7.5z"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}

export default Duplicate;
